// extracted by mini-css-extract-plugin
module.exports = {"error":"RefundHistoryVerificationFailedState_error__2o3MB"};